import Vue from 'vue';

const success = (context, response) => {
  context.rentals = response.rentals;
};

const failed = (context, error) => {

};

export default (context, forPermission = false) => {
  const permission = forPermission ? 'permission=true' : '';
  return Vue.$http.get(`rentals?${permission}`)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        failed(context, response);
      }
    }).catch((error) => {
      if (error) {
        failed(context, error);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getAll.js